<template>
    <div style="height:100%;width:100%;"
    class="bg-tran">

        <b-container id="vid-con">
            <b-row id="vid-row">  
<!--VIDEO POPUP-->
                <b-col style="margin-bottom: 1rem; height:100%;">
                <router-link :to="getColabHomePath(user)" :active="this.$route.path === this.getColabHomePath(this.user)">                    
                  <img :src="homeIcon" style="float:right; margin-top:2rem;"  
                    @mouseover="hov(true, 'i')"
                    @mouseleave="hov(false, 'i')"
                    class="icon pb-1"><br><!--:class="{ active : cal}"-->
                    <p v-if="this.$route.path === this.getColabHomePath(this.user)">Inicio</p>
                </router-link>
                  
                      
                    <b-row style="margin-top: 4rem; display: flex;justify-content: center;">
                       <!-- <h3 style="color: #005cc3;">CÓMO CALCULAR EL BONO</h3> -->
                            <video-player  class="vjs-custom-skin"
                                            ref="videoPlayer"
                                            :options="playerOptions"
                                            :playsinline="true"
                                            style="border-radius: 9px;"
                                            @play="onPlayerPlay($event)"
                                            @pause="onPlayerPause($event)"
                                            @ended="onPlayerEnded($event)"
                                            @loadeddata="onPlayerLoadeddata($event)"
                                            @waiting="onPlayerWaiting($event)"
                                            @playing="onPlayerPlaying($event)"
                                            @timeupdate="onPlayerTimeupdate($event)"
                                            @canplay="onPlayerCanplay($event)"
                                            @canplaythrough="onPlayerCanplaythrough($event)"
                                            @ready="playerReadied"
                                            @statechanged="playerStateChanged($event)">
                            </video-player>
                    </b-row> 
                </b-col>
            </b-row>
               

        </b-container>   
    </div>
</template>

<script>
import 'video.js/dist/video-js.css' 
import { videoPlayer } from 'vue-video-player'
import img from '../assets/fondoazul.png';
import flecha from '../assets/flecha-atras-blanca.png';
import hover_flecha from '../assets/flecha-atras.png';
import videoFanosa from '../assets/videofanosa.mp4'
import userService from '../services/user.service'

export default {
    name: 'Video',
    components: {videoPlayer},
    data() {
        return {
          user:null,
            background: img,
            homeIcon: flecha,
            home: true,
            // videojs options
            playerOptions: {
            height: '600rem',
            autoplay: false,
            muted: false,
            language: 'en',
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [{
                type: "video/mp4",
                // mp4
                src: videoFanosa,
                // webm
                // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
            }],
            // poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
            },  
        }
    },
    mounted() {
      // console.log('this is current player instance object', this.player)
      setTimeout(() => {
        //console.log('dynamic change options', this.player)
        this.player.muted(false)
      }, 5000)
    },  
    computed:{
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      // listen event
      onPlayerPlay(player) {
        // console.log('player play!', player)
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
      },
      onPlayerEnded(player) {
        // console.log('player ended!', player)
      },
      onPlayerLoadeddata(player) {
        // console.log('player Loadeddata!', player)
      },
      onPlayerWaiting(player) {
        // console.log('player Waiting!', player)
      },
      onPlayerPlaying(player) {
        // console.log('player Playing!', player)
      },
      onPlayerTimeupdate(player) {
        // console.log('player Timeupdate!', player.currentTime())
      },
      onPlayerCanplay(player) {
        // console.log('player Canplay!', player)
      },
      onPlayerCanplaythrough(player) {
        // console.log('player Canplaythrough!', player)
      },
      // or listen state event
      playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
      },
      // player is ready
      playerReadied(player) {
        // seek to 10s
        //console.log('example player 1 readied', player)
        player.currentTime(1)
        // console.log('example 01: the player is readied', player)
      },
        getColabHomePath: function(){
          
         let token = userService.getToken();
         let identity = userService.decode(token);
            let normalized = this.normalize(identity.city, identity.depto);            
            let code = identity.num;            
            return '/'+normalized.city+'/'+normalized.depto+'/'+code;
        },
        normalize: function(cities, deptos){
            let city = cities.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
            let depto = deptos.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
            return {city, depto};
        },
        hov: function(hover, key) {
            key === 'i' && hover === true ? this.homeIcon = flecha : this.homeIcon = hover_flecha;
            //console.log(this.$route.path === this.getColabHomePath(this.user))
        }
    },}
</script>
<style scoped>
div.bg-ran.py-4.col{
      width: 1022rem;
    /* padding-right: 15px; */
    /* padding-left: 15px; */
    /* margin-right: auto; */
    /* margin-left: auto;*/
}
.menu-op > a{
    font-family: 'FuturaPTMedium';
    color: #bcbcbc;
    font-size: 60%;
    margin-bottom: 0;
    text-transform: uppercase;
}
.menu-op > a:hover, .menu-op > .active{
    text-decoration: none;
    color: #4d78e7;
}
.icon{
    max-width: 1.5rem;
    cursor: pointer;
}
.icon2{
    max-width: 1.1rem;
    cursor: pointer;
}
.icon3{
    max-width: 1.6rem;
    cursor: pointer;
}
.wrapper {
    display: grid;
    grid-template-columns: auto;
    grid-auto-rows: auto;
}
.one {
  grid-column: 1;
  grid-row: 4;
}
.two {
  grid-column: 2;
  grid-row: 4;
}
.three {
  grid-column: 3;
  grid-row: 4;
}
.four {
  grid-column: 4;
  grid-row: 4;
}
.sticky{
    position: fixed;
    bottom: 0;
    background-color: white;
    border-top: 1px solid #f5f5f5b8;
}
</style>